// SuperAdmin → Users tab: role donut (incl. viewer), top-10 companies bar.
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import EChart from '../charts/EChart';
import { ChartCard, EmptyState } from './shared';

const ROLE_LABEL = {
  superadmin: 'SuperAdmin', admin: 'Admin', analyst: 'Analyst',
  simpleuser: 'Analyst', viewer: 'Viewer', consultant: 'Consultant'
};

const SuperUsers = ({ view, t }) => {
  const { usersByRole = {}, topCompanies = [] } = view;

  const donutOption = useMemo(() => {
    const entries = Object.entries(usersByRole).filter(([, v]) => Number(v) > 0);
    if (!entries.length) return null;
    return {
      tooltip: { trigger: 'item' },
      legend: { bottom: 0 },
      series: [{
        type: 'pie',
        radius: ['50%', '72%'],
        label: { show: false },
        data: entries.map(([role, value]) => ({ name: ROLE_LABEL[role] || role, value: Number(value) }))
      }]
    };
  }, [usersByRole]);

  const topOption = useMemo(() => {
    const safeTopCompanies = Array.isArray(topCompanies) ? topCompanies : [];
    const rows = safeTopCompanies.slice(0, 10);
    if (!rows.length) return null;
    return {
      tooltip: { trigger: 'axis' },
      grid: { left: 8, right: 48, top: 16, bottom: 16, containLabel: true },
      xAxis: { type: 'value' },
      yAxis: { type: 'category', data: rows.map((r) => r.name || '—') },
      series: [{ type: 'bar', data: rows.map((r) => r.users ?? r.value ?? 0), itemStyle: { borderRadius: [0, 4, 4, 0] } }]
    };
  }, [topCompanies]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <ChartCard title={t('rolesTitle')} subtitle={t('rolesSubtitle')}>
        {donutOption ? <EChart option={donutOption} height={320} /> : <EmptyState message={t('noUsers')} />}
      </ChartCard>
      <ChartCard title={t('topCompaniesTitle')} subtitle={t('topCompaniesSubtitle')}>
        {topOption ? <EChart option={topOption} height={320} /> : <EmptyState message={t('noTopCompanies')} />}
      </ChartCard>
    </div>
  );
};

SuperUsers.propTypes = {
  view: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default SuperUsers;
